import React from 'react';
import { Table } from 'reactstrap';
import TableLoader from 'components/TableLoader';
import { Link } from 'react-router-dom';
import { BSO } from './types';

interface Props {
  items: BSO[];
  isLoading: boolean;
}

export default function BSOTable(props: Props) {
  const { items, isLoading } = props;

  return (
    <>
      <Table className='align-items-center table-flush' responsive>
        <thead className="thead-light">
          <tr>
            <th>N°</th>
            <th>Remito</th>
            <th>Delegación</th>
            <th>Matriculado</th>
            <th>Periodo</th>
            <th>Importe</th>
            <th>N° Factura</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {
            !isLoading
              ? items.length
                ? items.map(row => (
                  <tr key={row.id}>
                    <td>#{row.id}</td>
                    <td>{row.remito_id}</td>
                    <td>{row.matriculate ? row.matriculate.delegacion : '-'}</td>
                    <td>{row.matriculate ? row.matriculate.matricula : '-'}</td>
                    <td>{`${row.monthPeriod}/${row.yearPeriod}`}</td>
                    <td>{row.amount}</td>
                    <td>{row.nroFactura || '-'}</td>
                    <td>{row.status}</td>
                    <td>
                      {
                        row.status === 'Presentado'
                          ? <Link
                              to={ `/admin/pedidos-presentacion/${row.id}/audit` }
                              className="btn btn-round btn-primary btn-sm"
                            >
                              <i className="fa fa-edit"></i>
                            </Link>
                          : <Link
                              to={ `/admin/pedidos-presentacion/${row.id}` }
                              className="btn btn-round btn-primary btn-sm"
                            >
                              <i className="fa fa-eye"></i>
                            </Link>
                      }
                    </td>
                  </tr>
                ))
                : <tr>
                    <td colSpan={ 9 } className='text-center'>
                      <span>No se encontraron pedidos de presentación</span>
                    </td>
                  </tr>
              : <tr>
                  <td colSpan={ 9 } className='text-center'>
                    <TableLoader />
                  </td>
                </tr>
          }
        </tbody>
      </Table>
    </>
  );
}
